export const DimensionUsage = Object.freeze({
  Query: 'USAGE_QUERY',
  NmsAlertPolicy: 'USAGE_KMETRICS_ALERT',
  FlowAlertPolicy: 'USAGE_FLOW_ALERT'
});
